import type { FilterResult } from '@components/Home/HomePageSearchModal'

/** The group a search result is shown under. */
export type SearchResultKind = 'quran' | 'dua' | 'tool'

export type SearchResultGroup = {
  kind: SearchResultKind
  title: string
  results: FilterResult[]
}

/** Group titles, in the order the groups are shown. */
const GROUP_TITLES: Record<SearchResultKind, string> = {
  quran: "Kur'an-ı Kerim",
  dua: 'Dualar',
  tool: 'Araçlar',
}

const GROUP_ORDER: SearchResultKind[] = ['quran', 'dua', 'tool']

/** URL prefixes of dua content: dua pages, Cevşen and community duas. */
const DUA_URL_PREFIXES = ['/dualar', '/cevsen', '/sizden-gelen-dualar']

/**
 * Decides a result's group from its URL: Quran (surahs, ayahs, pages, cüz), dua, or
 * an app tool. Done here instead of in `getHomeSearchResults`, so that function's
 * output stays identical to the legacy /api/home results.
 */
export const getSearchResultKind = (url: string): SearchResultKind => {
  if (url.startsWith('/kuran') || url.startsWith('/ayet')) return 'quran'
  if (DUA_URL_PREFIXES.some((prefix) => url.startsWith(prefix))) return 'dua'
  return 'tool'
}

/**
 * Splits search results into groups. The order inside each group is the order the
 * search returned them in; empty groups are left out.
 */
export const groupSearchResults = (results: FilterResult[]): SearchResultGroup[] =>
  GROUP_ORDER.map((kind) => ({
    kind,
    title: GROUP_TITLES[kind],
    results: results.filter((result) => getSearchResultKind(result.url) === kind),
  })).filter((group) => group.results.length > 0)
